<template>
	<div>

		<!-- qColumnHeader = {{ qColumnHeader }}<br /><br />
		qColumns = {{ qColumns }}<br /><br />
		qColumns.length = {{ qColumns.length }}<br /><br /> -->

		<div  v-if="qColumns[0]">
			<!--Column layout for dynamic Organization sections (no row labels/titles)-->
			<div v-if="qColumns[0].title">

				<!--1st column header-->
				<v-layout>
					<v-flex :style="{'min-width': getTopColumnHeadingWidth() }" xs1>
						<p class="column-header" v-html="qColumnHeader" />
					</v-flex>
				</v-layout>

				<!--2nd column header-->
				<v-layout v-if="qColumns[0].title" />
				<v-layout v-else>
					<v-flex
					:style="{'min-width':getColumnHeadingWidth()}"
					v-for="(titleSection, index) in qColumns"
						:xs3="index == 0 || qColumns[index].labels.length == 3"
						:xs4="qColumns[index2].labels.length == 4"
						:xs5="qColumns[index2].labels.length == 5"
						:xs6="qColumns[index2].labels.length == 6">
						<p class="column-header">{{titleSection.title}}</p>
					</v-flex>
				</v-layout>

				<!--3rd column header: When there are THREE 2nd column headers-->
				<v-layout v-if="qColumns.length === 3">
					<v-flex class="column-header" style="min-width: 150px; max-width: 150px;" xs2>
						<p>
							({{ qColumns[0].labels[0].id }})
							<br />
							{{ qColumns[0].labels[0].label }}
						</p>
					</v-flex>
					<v-flex class="column-header" style="min-width: 150px; max-width: 150px;" xs1>
						<p>
							({{ qColumns[0].labels[1].id }})
							<br />
							{{ qColumns[0].labels[1].label }}
						</p>
					</v-flex>
					<v-flex class="column-header right-divider" style="min-width: 150px; max-width: 150px;" xs1>
						<p>
							({{ qColumns[0].labels[2].id }})
							<br />
							{{ qColumns[0].labels[2].label }}
						</p>
					</v-flex>
					<v-flex
						v-for="(col, index) in qColumns[1].labels"
						xs1 v-bind:class="addRightDivider(index + 1, qColumns[1].labels.length)" style="min-width:150px; max-width: 150px">
						<p class="column-header">
							({{ col.id }})
							<br />
							{{ col.label }}
						</p>
					</v-flex>
					<v-flex
						v-for="(col, index) in qColumns[2].labels"
						xs1 v-bind:class="addRightDivider(index + 1, qColumns[2].labels.length)"
						style="min-width:150px; max-width: 150px">
						<p class="column-header">
							({{ col.id }})
							<br />
							{{ col.label }}
						</p>
					</v-flex>
				</v-layout>

				<!--3rd column header: When there are TWO 2nd column headers-->
				<v-layout v-if="qColumns.length === 2">
					<v-flex class="column-header" style="min-width: 160px; max-width: 160px;" xs2>
						<p>
							({{ qColumns[0].labels[0].id }})
							<br />
							{{ qColumns[0].labels[0].label }}
						</p>
					</v-flex>
					<v-flex class="column-header" style="min-width: 160px; max-width: 160px;" xs1>
						<p>
							({{ qColumns[0].labels[1].id }})
							<br />
							{{ qColumns[0].labels[1].label }}
						</p>
					</v-flex>
					<v-flex class="column-header right-divider" style="min-width: 160px; max-width: 160px;" xs1>
						<p>
							({{ qColumns[0].labels[2].id }})
							<br />
							{{ qColumns[0].labels[2].label }}
						</p>
					</v-flex>
					<v-flex
						v-for="(col, index) in qColumns[1].labels"
						xs1 v-bind:class="addRightDivider(index + 1, qColumns[1].labels.length)"
						style="min-width: 150px; max-width: 150px;">
						<p class="column-header">
							({{ col.id }})
							<br />
							{{ col.label }}
						</p>
					</v-flex>
				</v-layout>
			</div>

			<!--Column layout for sections with row labels/titles-->
			<div v-else>
					<v-layout v-if="qColumnHeader">
						<v-flex class="left-label" xs3 />
						<v-flex :style="{'min-width': getColumnHeadingWidth() }"
										:xs1="qColumns.length == 1 && qId != '4'"
										:xs2="qColumns.length == 2"
										:xs3="qColumns.length == 3"
										:xs4="qColumns.length == 4"
										:xs5="qColumns.length == 5"
										:xs6="qColumns.length == 6 || qId == '4'"
										:xs7="qColumns.length == 7">
							<p class="column-header" v-html="qColumnHeader" />
						</v-flex>
					</v-layout>
					<v-layout>
						<v-flex class="left-label" xs3 />
						<v-flex class="tb-width" v-for="col in qColumns" :key="col.colHeader" xs1>
							<p v-if="col.label" class="column-header">
								({{ col.id }})
								<br />
								{{ col.label }}
							</p>
						</v-flex>
					</v-layout>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "AnswersColumns",
		props: {
			columns: Array,
			columnHeader: String,
			qId: String
		},
		data: () => ({
			qColumns: [],
			qColumnHeader: null
		}),
		watch: {
			columns: function (newVal, oldVal) {
				this.qColumns = newVal;
			},
			columnHeader: function (newVal, oldVal) {
				this.qColumnHeader = newVal;
			}
		},
		methods: {
		getTotalNumColWidths () {
			   debugger;
				var numCols = 0;
				var i;
				for (i = 0; i < this.qColumns.length; i++) {
					// console.log('this.qColumns.length: ' + this.qColumns.length);
					var j;
					for (j = 0; j < this.qColumns[i].labels.length; j++) {
						// console.log('this.qColumns[' + i + '].labels.length: ' + this.qColumns[i].labels.length);
						numCols++;
					}
				}
				numCols++;
				return numCols;
			},
			getTopColumnHeadingWidth () {
				var width = 200;
				width = width * this.getTotalNumColWidths().toString() + "px";
				return width;
			},
			getColumnHeadingWidth () {
				var width = 100;
				width = width * this.qColumns.length.toString() + "px";
				if (this.qId === '4') {
					width = '825px';
				}
				// console.log('width for cols ' + this.qColumns.length.toString() + ' is: ' + width);
				return width;
			},
			addRightDivider (pos, length) {
				return {
					'right-divider': pos === length
				}
			}
		}
	};
</script>

<style scoped>
	.column-header {
		text-align: center;
		font-weight: bold;
	}
		.left-label {
   		min-width: 450px;
	}
	.left-label-other {
		min-width: 330px;
		/* border-style: solid; */
	}
	.tb-width {
		min-width: 150px;
	}
	.tb-width-other {
		min-width: 125px;
		border-right: 1px solid black;
		/* border-style: solid; */
	}
	.right-divider {
		border-right: 1px solid black;
	}
</style>
